module.exports = "<headerMenu></headerMenu>\r\n\r\n<app-payment-receipt-store></app-payment-receipt-store>"


//////////////////
// WEBPACK FOOTER
// ./src/app/dash-board/paymernt-receipt-container/payment-receipt-container-store/payment-receipt-container-store.component.html
// module id = ./src/app/dash-board/paymernt-receipt-container/payment-receipt-container-store/payment-receipt-container-store.component.html
// module chunks = main